import { Grid2, Skeleton } from "@mui/material"
import Container from "../Container"
import { memo } from "react"

const BranchCardSkeleton = memo(({ hideButtons = false }: { hideButtons?: boolean }) => {

    return (
        <Grid2 container size={'grow'} sx={{ backgroundColor: 'rgba(0,0,0,0.05)', backdropFilter: "none" }} minWidth={{ xs: '100%', lg: '20vw' }} height={'30vh'} borderRadius={2}>
            <Grid2 container size={'grow'} flexDirection={'column'} justifyContent={'space-between'} padding={3}>
                <Grid2 container display={'flex'} justifyContent={hideButtons ? 'end' : 'space-between'} alignItems={'center'}>
                    <Container container size={'auto'} display={hideButtons ? 'none' : 'flex'} alignItems={'center'} paddingX={1} spacing={2} sx={{ backgroundColor: 'rgba(0,0,0,0.05)', backdropFilter: 'none' }}>
                        <Grid2 paddingY={1}>
                            <Skeleton variant="circular" width={40} height={40} />
                        </Grid2>
                        <Grid2 paddingY={1}>
                            <Skeleton variant="circular" width={40} height={40} />
                        </Grid2>
                    </Container>

                    <Grid2 width={{ xs: 50, lg: '4vw' }} height={{ xs: 50, lg: '4vw' }}>
                        <Skeleton variant="circular" width={'100%'} height={'100%'} />
                    </Grid2>
                </Grid2>
                <Grid2>
                    <Skeleton variant="text" sx={{ fontSize: '3rem' }} />
                </Grid2>
            </Grid2>
        </Grid2>
    )
})

export default BranchCardSkeleton